import React from "react";
import versionInfo from "../../version.json";

const VersionDisplay = () => {
    const { buildDate, gitTag } = versionInfo;

    return (
        <div style={{ padding: 30, fontFamily: "unset" }}>
            <h4 className="">Application Version Info</h4>
            <p><strong>version:</strong> {gitTag}</p>
            <p><strong>Build Date:</strong> {new Date(buildDate).toLocaleString()}</p>
        </div>
        );
};
export default VersionDisplay;
